// A "TV tab" is a browser tab that is the big screen of a room (TV mode). It is
// opened with ?tv=1 or from the /tv start page, and it has an identity of its
// own: its sign-in lives in that tab only, never in your account. So the same
// person can host on a TV and play from their phone with their own account.
const FLAG = "partycade.tvtab";
const SOLO = "partycade.solo";

export function isTvTab() {
  try {
    if (sessionStorage.getItem(FLAG) === "1") return true;
    const url = new URL(window.location.href);
    return url.searchParams.get("tv") === "1" || /^\/tv(\/|$)/.test(url.pathname);
  } catch {
    return false;
  }
}

// Called once, before sign-in starts (see firebase.js).
export function rememberTvTab() {
  try {
    if (!isTvTab()) return;
    sessionStorage.setItem(FLAG, "1");
    // The same switch the dev "?solo" mode uses: this tab keeps its own sign-in.
    sessionStorage.setItem(SOLO, "1");
  } catch {}
}

// Leave TV mode: forget that this tab is a TV and go home. The page reloads, so
// your own account (kept in the browser, not in this tab) is loaded again.
export function leaveTvMode() {
  try {
    sessionStorage.removeItem(FLAG);
    sessionStorage.removeItem(SOLO);
    sessionStorage.removeItem("partycade.tvreload");
    forgetTvRoom();
  } catch {}
  window.location.assign("/");
}

// A tab that turned into a TV after the page had already loaded (the old
// account is still in memory) reloads once so it starts as a clean guest.
export function reloadAsTvTab() {
  try {
    if (sessionStorage.getItem("partycade.tvreload")) return;
    sessionStorage.setItem("partycade.tvreload", "1");
  } catch {
    return;
  }
  window.location.reload();
}

export const TV_NAME = "TV";
export const TV_AVATAR = { emoji: "📺", color: "#2d7ff9" };

// The last room this device was the screen of, so the TV can find its way back
// (after Leave, a closed tab or a refresh). Shared by every tab of the browser.
const LAST_KEY = "partycade.tvRoom";
const LAST_MAX_AGE = 24 * 3_600_000;

export function rememberTvRoom(code) {
  try {
    localStorage.setItem(LAST_KEY, JSON.stringify({ code, at: Date.now() }));
  } catch {}
}

export function lastTvRoom() {
  try {
    const last = JSON.parse(localStorage.getItem(LAST_KEY));
    return last?.code && Date.now() - last.at < LAST_MAX_AGE ? last.code : null;
  } catch {
    return null;
  }
}

export function forgetTvRoom() {
  try {
    localStorage.removeItem(LAST_KEY);
  } catch {}
}

export const screenLink = (code) => `${window.location.origin}/r/${code}?tv=1`;
